import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RideVerification } from '../../models';
import { Deserialize } from 'cerialize';

@Injectable({
  providedIn: 'root'
})
export class RideVerificationService extends UzurvRestService {
  readonly resourceUrl = 'rideVerification/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   *
   *
   * @param driverCode
   *
   */
  getRideVerification(driverCode: string): Observable<RideVerification> {
    return this.get<RideVerification>(this.resourceUrl, { driverCode }).pipe(map(response => Deserialize(response, RideVerification)));
  }
}
